export const API_AUTHENTICATION_FAILED_EVENT = 'palen:api-authentication-failed';
